import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Download: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="Downlaod"><path id="Stroke 1" d="M12.0002 15.4138L12.0002 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path id="Stroke 3" d="M14.5222 12.8818L12.0003 15.4141L9.47832 12.8818" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path id="Stroke 4" d="M16.0069 9.09332H16.8138C18.5738 9.09332 20 10.5195 20 12.2803V16.5044C20 18.26 18.5773 19.6827 16.8216 19.6827H7.18703C5.42703 19.6827 4 18.2557 4 16.4957V12.2708C4 10.516 5.42357 9.09332 7.17838 9.09332H7.99308" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} fill="none" stroke="currentColor" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};